const STORAGE_KEY = "team_invites_v1";

export function generateInviteToken() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}

export function loadInvites() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error("Failed to load invites from localStorage:", error);
    return [];
  }
}

export function saveInvites(invites) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(invites));
  } catch (error) {
    console.error("Failed to save invites to localStorage:", error);
  }
}

export function addInvite(invite) {
  const invites = loadInvites();
  invites.unshift(invite);
  saveInvites(invites);
}

export function updateInvite(token, updates) {
  const invites = loadInvites();
  const index = invites.findIndex((inv) => inv.token === token);
  if (index !== -1) {
    invites[index] = { ...invites[index], ...updates };
    saveInvites(invites);
  }
}

export function findInviteByToken(token) {
  const invites = loadInvites();
  return invites.find((inv) => inv.token === token) || null;
}

export function generateInviteLink(token) {
  return `${window.location.origin}/invite/accept?token=${token}`;
}

export function getEmailInitials(email) {
  if (!email) return "?";
  const parts = email.split("@")[0].split(/[._-]/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return email[0].toUpperCase();
}
